import React, { useRef, useState, useEffect } from 'react';
import update from 'immutability-helper';

import Appearance from 'styles/Appearance';
import TextField from 'views/TextField.js';
import { VelocityComponent } from 'velocity-react';

const Alert = ({ id, buttons, component, icon, index, message, onClick, onClose, textFields, title, twoFactor, utils }) => {

    const [visible, setVisible] = useState(false);
    const [scale, setScale] = useState(0);
    const [opacity, setOpacity] = useState(0);
    const [alertButtons, setAlertButtons] = useState([]);
    const [alertTextFields, setAlertTextFields] = useState(false);
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    })

    const [componentValue, setComponentValue] = useState(component ? component.value : null);

    const twoFactorRefOne = useRef(null);
    const twoFactorRefTwo = useRef(null);
    const twoFactorRefThree = useRef(null);
    const twoFactorRefFour = useRef(null);
    const twoFactorRefFive = useRef(null);
    const twoFactorRefSix = useRef(null);

    const handleKeyDown = (e) => {
        if(e.keyCode === 13) {
            e.preventDefault();
            //e.stopPropagation();
            hide(() => {
                parseTextFields()
            });
        }
    }

    const hide = (callback) => {
        setScale(0);
        setOpacity(0);
        setTimeout(() => {
            setVisible(false);
            if(typeof(onClose) === 'function') {
                onClose(id);
            }
            if(typeof(callback) === 'function') {
                callback();
            }
        }, 250);
    }

    const parseTextFields = (key) => {
        if(typeof(onClose) === 'function') {
            onClose(id);
        }
        if(key !== 'cancel' && key !== 'dismiss') {
            if(onClick && typeof(onClick) === 'function') {
                let textFieldValues = {};
                alertTextFields.forEach(t => {
                    textFieldValues[t.field.key] = t.value;
                })
                onClick(textFieldValues);
            }
        }
    }

    const buttonPress = (key) => {

        let twoFactorText = '';
        if(twoFactor) {
            twoFactorText = [
                twoFactorRefOne,
                twoFactorRefTwo,
                twoFactorRefThree,
                twoFactorRefFour,
                twoFactorRefFive,
                twoFactorRefSix
            ].reduce((string, ref) => {
                return string += ref.current.value;
            }, '');
        }

        // Specialty components
        if(component && typeof(onClick) === 'function') {
            onClick(componentValue);
            hide();
            return;
        }

        hide(() => {
            if(alertTextFields) {
                parseTextFields(key);
                return;
            }
            if(twoFactor) {
                if(twoFactorText.length === 6) {
                    if(typeof(onClick) === 'function') {
                        onClick({ twoFactor: twoFactorText });
                    }
                }
                return;
            }
            if(typeof(onClick) === 'function') {
                onClick(key);
            }
        });
    }

    const onTwoFactorTextChange = (value, int) => {

        if(value === 'backspace') {
            let ref = null;
            switch(int) {
                case 2:
                    ref = twoFactorRefOne;
                    break;
                case 3:
                    ref = twoFactorRefTwo;
                    break;
                case 4:
                    ref = twoFactorRefThree;
                    break;
                case 5:
                    ref = twoFactorRefFour;
                    break;
                case 6:
                    ref = twoFactorRefFive;
                    break;
                default:
                    return;
            }
            if(!ref || !ref.current) {
                return;
            }
            ref.current.focus();
            return;
        }

        // Get next ref
        let ref = null;
        switch(int) {
            case 1:
                ref = twoFactorRefTwo;
                break;
            case 2:
                ref = twoFactorRefThree;
                break;
            case 3:
                ref = twoFactorRefFour;
                break;
            case 4:
                ref = twoFactorRefFive;
                break;
            case 5:
                ref = twoFactorRefSix;
                break;
            default:
                return;
        }
        if(!ref || !ref.current) {
            return;
        }
        ref.current.focus();
    }

    const getContent = () => {
        
        if(alertTextFields) {
            return (
                <div style={{
                    paddingLeft: 15,
                    paddingRight: 15,
                    width: '100%',
                    marginBottom: 15
                }}>
                    {alertTextFields.map((item, index) => {
                        return (
                            <TextField
                            key={index}
                            value={item.value}
                            useDelay={false}
                            isSecure={item.field.secure}
                            placeholder={item.field.placeholder}
                            fieldStyle={{
                                textAlign: 'center'
                            }}
                            onChange={text => {
                                setAlertTextFields(alertTextFields => update(alertTextFields, {
                                    [index]: {
                                        value: {
                                            $set: text
                                        }
                                    }
                                }))
                            }} />
                        )
                    })}
                </div>
            )
        }

        if(twoFactor) {
            return (
                <div style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    paddingLeft: 12,
                    paddingRight: 12,
                    marginBottom: 20
                }}>
                    {[1,2,3,4,5,6].map((int, index) => {

                        let ref = null;
                        switch(int) {
                            case 1:
                            ref = twoFactorRefOne;
                            break;

                            case 2:
                            ref = twoFactorRefTwo;
                            break;

                            case 3:
                            ref = twoFactorRefThree;
                            break;

                            case 4:
                            ref = twoFactorRefFour;
                            break;

                            case 5:
                            ref = twoFactorRefFive;
                            break;

                            case 6:
                            ref = twoFactorRefSix;
                            break;
                        }

                        return (
                            <TextField ref={ref}
                            key={index}
                            useDelay={false}
                            onKeyDown={key => onTwoFactorTextChange(key, int)}
                            containerStyle={{
                                marginLeft: 4,
                                marginRight: 4,
                                height: 40,
                                width: 35,
                                minWidth: 35,
                                padding: 0
                            }}
                            inputStyle={{
                                fontSize: 20,
                                fontWeight: '600',
                                color: Appearance.colors.text(),
                                textAlign: 'center'
                            }}/>
                        )
                    })}
                </div>
            )
        }
    }

    const onWindowSizeChange = (e) => {
        setSize({
            width: window.innerWidth,
            height: window.innerHeight
        })
    }

    useEffect(() => {
        setAlertTextFields(textFields ? textFields.map(t => {
            return {
                value: null,
                field: t
            }
        }) : null);
    }, [textFields]);

    useEffect(() => {
        setVisible(true);
        setTimeout(() => {
            setScale(index > 3 ? 0 : 1 - (index / 4));
            setOpacity(index === 0 ? 1 : 0);
        }, 100)
    }, [index])

    useEffect(() => {

        let nextButtons = buttons || [{
            key: 'dismiss',
            title: 'Dismiss',
            style: 'cancel'
        }];
        setAlertButtons(nextButtons.filter(button => {
            return button.visible !== false;
        }));

        window.addEventListener('resize', onWindowSizeChange);
        return () => {
            window.removeEventListener('resize', onWindowSizeChange);
        }
    }, []);

    useEffect(() => {
        if(alertTextFields) {
            document.addEventListener('keydown', handleKeyDown);
            return () => {
                document.removeEventListener('keydown', handleKeyDown);
            }
        }
    }, [alertTextFields])

    return visible ? (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: Appearance.colors.transparent,
            zIndex: 9950
        }}>
            <VelocityComponent
            easing={[250, 20]}
            duration={500}
            animation={{
                opacity: opacity,
                scale: scale
            }}>
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    borderRadius: 10,
                    backgroundColor: Appearance.colors.alert(),
                    overflow: 'hidden',
                    maxHeight: size.height - 30,
                    width: size.width > 300 ? 300 : (size.width - 30),
                    alignItems: 'center',
                    textAlign: 'center',
                    zIndex: 9999
                }}>
                    {icon
                        ?
                        <div style={{
                            marginTop: 15,
                            borderRadius: 25,
                            backgroundColor: icon.background_color || Appearance.colors.primary(utils),
                            overflow: 'hidden',
                            width: 50,
                            height: 50,
                            border: '3px solid white',
                            boxShadow: window.theme === 'dark' ? '3px 3px 15px rgba(0,0,0,0.25), -3px -3px 15px rgba(255,255,255,0.25)' : '3px 3px 15px #c9c8ca, -3px -3px 15px #ffffff',
                            ...icon.style
                        }}>
                            <img src={icon.path} style={{
                                width: '100%',
                                height: '100%',
                                resizeMode: 'cover'
                            }}/>
                        </div>
                        :
                        null
                    }
                    <span style={{
                        display: 'block',
                        color: Appearance.colors.text(),
                        fontSize: 18,
                        fontWeight: '800',
                        lineHeight: 1.5,
                        marginBottom: 4,
                        paddingTop: icon ? 8:15,
                        paddingLeft: 15,
                        paddingRight: 15,
                    }}>{title}</span>

                    <div style={{
                        marginBottom: 15,
                        maxHeight: 500,
                        overflowY: 'scroll',
                        overflowX: 'hidden',
                        maxWidth: '100%'
                    }}>
                        <span style={{
                            display: 'block',
                            maxWidth: '100%',
                            color: Appearance.colors.subText(),
                            fontSize: 13,
                            fontWeight: '500',
                            paddingLeft: 15,
                            paddingRight: 15,
                            wordWrap: 'break-word'
                        }}>{message}</span>
                    </div>

                    {getContent()}

                    {alertButtons.map(item => {

                        return (
                            <div
                            key={item.key}
                            className={`alert-item ${window.theme}`}
                            onClick={() => buttonPress(item.key)}
                            style={{
                                height: 50,
                                width: '100%'
                            }}>
                                <div style={{
                                    height: 50
                                }}>
                                    <div style={{
                                        width: '100%',
                                        height: 1,
                                        backgroundColor: Appearance.colors.divider()
                                    }}/>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        height: 50
                                    }}>
                                        <span style={{
                                            fontSize: '13px',
                                            fontWeight: '400',
                                            textAlign:'center',
                                            color: (item.style == 'cancel' || item.style == 'destructive') ? Appearance.colors.text() : Appearance.colors.primary(utils)
                                        }}>{item.title}</span>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </VelocityComponent>
        </div>
    ) : null
}

export default Alert;
